import { ReactNode } from 'react';
import type { AutomationTemplate } from '../engage-automations-tab/templates.types';
import { AutomationEditorContext } from './AutomationEditorContext';
import { useAutomationEditor } from './useAutomationEditor';

interface AutomationEditorProviderProps {
  template: AutomationTemplate;
  children: ReactNode;
}

export function AutomationEditorProvider({
  template,
  children,
}: AutomationEditorProviderProps) {
  const editor = useAutomationEditor(template);

  return (
    <AutomationEditorContext.Provider value={{ editor }}>
      {children}
    </AutomationEditorContext.Provider>
  );
}
